import { Component } from '@angular/core';
import { AnalyticService, NotifyService } from '@app/services';
import { ActivatedRoute, Router } from '@angular/router';
import { JobFunnelMessageTemplateForm } from '@app/modules/forms/applicant-tracker/components';
import { Location } from '@angular/common';
import { CanDeactivateComponent } from '@app/interfaces';
import { JobFunnelMessageTemplate } from '@models/recruiting/job-funnel-message-template.model';
import { JobFunnel } from '@models/recruiting/job-funnel.model';
import { AnalyticEvents } from '@app/enums';

@Component({
    templateUrl: './job-funnel-message-template-update.template.html',
})
export class JobFunnelMessageTemplateUpdateView implements CanDeactivateComponent {
    isLoading = false;
    jobFunnel: JobFunnel;
    jobFunnelMessageTemplate: JobFunnelMessageTemplate;
    isSaveBulkEmailModalOpen = false;
    isRemoveModalOpen = false;
    isDeactivateModalOpen = false;
    canNavigateBack = true;
    previousPath: string;

    constructor(
        private route: ActivatedRoute,
        private notifyService: NotifyService,
        private analyticService: AnalyticService,
        private location: Location,
        private router: Router
    ) {
        this.jobFunnel = this.route.snapshot.data.models.get('jobFunnel');
        this.jobFunnelMessageTemplate = this.route.snapshot.data.models.get('jobFunnelMessageTemplate');
    }

    canDeactivate(): boolean {
        if (this.jobFunnelMessageTemplate.body) {
            this.canNavigateBack = false;
            this.isDeactivateModalOpen = true;
            this.previousPath = this.previousPath ?? this.location.path();
        }

        return this.canNavigateBack;
    }

    allowNavigation(): void {
        this.canNavigateBack = true;
        this.jobFunnelMessageTemplate.body = '';
        this.router.navigateByUrl(this.previousPath);
    }

    openSaveBulkEmail(): void {
        this.isSaveBulkEmailModalOpen = true;
    }

    closeSaveBulkEmail(): void {
        this.isSaveBulkEmailModalOpen = false;
    }

    openRemoveModal(): void {
        this.isRemoveModalOpen = true;
    }

    closeRemoveModal(): void {
        this.isRemoveModalOpen = false;
    }

    closeDeactivateModalOpen(): void {
        this.isDeactivateModalOpen = false;
    }

    async onSave(jobFunnelMessageTemplateForm: JobFunnelMessageTemplateForm): Promise<void> {
        jobFunnelMessageTemplateForm.submit();

        if (!jobFunnelMessageTemplateForm.valid) {
            this.closeSaveBulkEmail();
            return;
        }

        this.isLoading = true;

        try {
            await this.jobFunnelMessageTemplate.save();

            this.notifyService.success({
                key: 'applicant-tracker.savedChangesToSubjectInStage',
                params: { subject: this.jobFunnelMessageTemplate.subject ?? '', stageName: this.jobFunnel.funnelStep },
            });

            this.analyticService.trackEvent(AnalyticEvents.RecruitingJobPostingFunnelMeatballEditEmailAutomationSave);

            this.jobFunnelMessageTemplate.body = '';
            this.canNavigateBack = true;
            this.previousPath ? this.router.navigateByUrl(this.previousPath) : this.location.back();
        } catch (err) {
            this.notifyService.error('applicant-tracker.failedToSaveATemplate');
        } finally {
            this.isLoading = false;
        }

        this.closeSaveBulkEmail();
    }

    async onRemove(): Promise<void> {
        this.isLoading = true;
        try {
            await this.jobFunnelMessageTemplate.delete();

            this.notifyService.success({
                key: 'applicant-tracker.subjectWasRemovedFromStageName',
                params: { subject: this.jobFunnelMessageTemplate.subject ?? '', stageName: this.jobFunnel.funnelStep },
            });

            this.analyticService.trackEvent(
                AnalyticEvents.RecruitingJobPostingFunnelMeatballEditEmailAutomationRemoveClickRemoveToSave
            );

            this.jobFunnelMessageTemplate.body = '';
            this.canNavigateBack = true;
            this.previousPath ? this.router.navigateByUrl(this.previousPath) : this.location.back();
        } catch (err) {
            this.notifyService.error(err);
        } finally {
            this.isLoading = false;
        }
    }
}
